const breakpoints = {
	smallMobile: -374,
	smallTablet: 550,
	tablet: 768,
	smallDesktop: 1024,
	desktop: 1280,
	largeDesktop: 1600,
};

export default breakpoints;
